/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, ReactElement, Dispatch, useCallback } from 'react';
import styled from '@emotion/styled';
import { Flex } from 'reflexbox';
import { connect } from 'react-redux';

import { SvgOpenLearning } from './images/OpenLearning';
import { SvgBurger } from './images/Burger';
import { SvgActiveBurger } from './images/ActiveBurger';
import { CourseDropdown } from './CourseDropdown/index';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../Style/breakpoints';
import { ReduxState } from '../../../../ReduxStorage/state';
import {
  selectLoginLink,
  selectSignupLink,
} from '../../../../ReduxStorage/Auth/Login/selectors';
import { ReduxAction } from '../../../../ReduxStorage/actions';
import { loginRequired } from '../../../../ReduxStorage/Auth/dispatchers.web';
import { TopbarProps } from './types';
import { ConnectedLoginModal } from '../../../containers/LoginModal/LoginModal';
import { makeMetricsLogEvent } from '../../../../ReduxStorage/Metrics/manualEventDispatchers';
import { RouteLink } from '../../RouteLink/component';

const Container = styled.div`
  display: flex;
  padding: 12px;
  background: #ffffff;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15);
  z-index: 10;
  position: relative;
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    display: flex;
    align-items: center;
    flex-grow: 1;
    flex-direction: row;
  }
`;
const Right = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    align-items: center;
    justify-content: flex-end;
    flex-direction: row;
  }
`;

const NavBar = styled.nav`
  display: flex;
  flex-direction: column;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    display: inline-flex;
    align-items: center;
    // padding: 0 24px;
    flex-direction: row;
  }
`;

const BurgerContainer = styled(Flex)`
  align-items: center;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    display: none;
  }
`;

const OpenLearningIconContainer = styled(Flex)`
  flex-grow: 1;
  justify-content: center;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    flex-grow: 0;
  }
`;

const NavContainer = styled(Flex)`
  position: absolute;
  top: 88px;
  left: 0;
  right: 0;
  z-index: 1;
  flex-direction: column;
  background: #fff;
  display: none;
  &.show {
    display: flex;
  }
  &.hide {
    display: none;
  }
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    display: flex;
    flex-grow: 1;
    position: initial;
    flex-direction: row;
    background: transparent;
    top: 0;
    &.show {
      display: flex;
    }
    &.hide {
      display: flex;
    }
  }
`;

const LogoContainer = styled(Flex)`
  flex-grow: 1;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    flex-grow: 0;
    min-width: 258px;
  }
`;

export const _TopBar = (props: TopbarProps): ReactElement => {
  const { loginLink, signupLink, onLogin, makeCourseFilterEvent } = props;
  const [isMenuActive, setIsMenuActive] = useState(false);
  const BurgerClickedHandler = (): void => {
    setIsMenuActive(!isMenuActive);
  };

  const StyledLink = styled(RouteLink)`
    font-family: Avenir, sans-serif;
    text-decoration: none;
    border-top: 1px solid #e5eaeb;
    padding: 14px 16px;
    font-weight: normal;
    font-size: 16px;
    line-height: 140%;
    display: flex;
    align-items: center;
    color: #000000;

    &:hover {
      color: #cf1b53;
    }
    @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
      font-family: Avenir, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 140%;
      color: #3e4b4c;
      padding: 0 12px;
      border-top: none;
 `;

  const SignUpLink = styled(StyledLink)`
    font-family: Avenir, sans-serif;
    text-decoration: none;
    border-top: 1px solid #e5eaeb;
    padding: 14px 16px;
    font-weight: normal;
    font-size: 16px;
    line-height: 140%;
    display: flex;
    align-items: center;
    color: #000000;

    &:hover {
      color: #cf1b53;
    }
    @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
      font-style: normal;
      font-weight: 800;
      font-size: 16px;
      line-height: 140%;
      color: #3e4b4c;
      padding: 0 12px;
      border-top: none;
    }
  `;

  const login = (e: React.MouseEvent): void => {
    e.preventDefault();
    onLogin('login');
  };

  const signup = (e: React.MouseEvent): void => {
    e.preventDefault();
    onLogin('signup');
  };

  const onClickLogin = useCallback(login, []);

  const onClickSignup = useCallback(signup, []);

  return (
    <Container>
      <ConnectedLoginModal />
      <LogoContainer>
        <BurgerContainer onClick={BurgerClickedHandler}>
          {isMenuActive ? <SvgActiveBurger /> : <SvgBurger />}
        </BurgerContainer>
        <OpenLearningIconContainer>
          <RouteLink to={{ type: 'ROUTE_HOMEPAGE' }}>
            <SvgOpenLearning />
          </RouteLink>
        </OpenLearningIconContainer>
      </LogoContainer>
      <NavContainer className={isMenuActive ? 'show' : 'hide'}>
        <Left>
          <NavBar>
            <CourseDropdown
              name="Courses"
              makeCourseFilterEvent={makeCourseFilterEvent}
            />
            <StyledLink to={{ type: 'ROUTE_PARTNERS_LISTING_PAGE' }}>
              Partners
            </StyledLink>
          </NavBar>
        </Left>
        <Right>
          <StyledLink to={loginLink}>
            <span onClick={onClickLogin}>Log in</span>
          </StyledLink>
          <SignUpLink to={signupLink}>
            <span onClick={onClickSignup}>Sign up</span>
          </SignUpLink>
        </Right>
      </NavContainer>
    </Container>
  );
};

export const TopBar = connect(
  (state: ReduxState) => ({
    loginLink: selectLoginLink(state), // links to accounts/login
    signupLink: selectSignupLink(state), // links to accounts/register
  }),
  (dispatch: Dispatch<ReduxAction>) => ({
    onLogin: (mode: string): void => {
      dispatch(
        loginRequired(() => {
          window.location.reload();
        }, mode)
      );
    },
    makeCourseFilterEvent: (name: string, values: string[]): void => {
      dispatch(
        makeMetricsLogEvent('CourseDiscoveryFilter-Applied', {
          filterLocation: 'topbar',
          selectedFilterGroup: name,
          selectedFilterValue: values,
        })
      );
    },
  })
)(_TopBar);
